import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ErrorDialogComponent } from "../components/error-dialog/error-dialog.component";

@Injectable()
export class ErrorDialogService {
  private opened = false;

  /**
   * Constructor
   * @param dialog Dialog to show.
   */
  constructor(private dialog: MatDialog) {}

  /**
   * Open the dialog
   * @param message Message to display
   * @param status Status to show.
   */
  openDialog(message: string, status?: number): void {
    // if (!this.opened) {
    //   this.opened = true;
    //   const dialogRef = this.dialog.open(ErrorDialogComponent, {
    //     data: { message, status },
    //     maxHeight: "100%",
    //     width: "540px",
    //     maxWidth: "100%",
    //     disableClose: true,
    //     hasBackdrop: true
    //   });
    //
    //   dialogRef.afterClosed().subscribe(() => {
    //     this.opened = false;
    //   });
    // }
  }
}
